import { ReactNode } from 'react';

import clsx from 'clsx';
import { Typography, Stack, tokens } from '@cast/design-system';

type Props = {
  title?: string;
  showTitleInDemo?: boolean;
  children: ReactNode;
};

export const SidebarSection = ({ title, children, showTitleInDemo }: Props) => {
  return (
    <Stack gap={4}>
      {!!title && (
        <Typography
          variant="L10B"
          color={tokens.theme.fg.structural.secondary}
          px={4}
          py={8}
          data-testid="sidebar-section-title"
          className={clsx(showTitleInDemo && 'ignore-blur')}
        >
          {title}
        </Typography>
      )}
      <Stack gap={4}>{children}</Stack>
    </Stack>
  );
};
